import { IVersionsResponseDto } from './dto/VersionsDto'
import { api } from './BaseApi'

export const versionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getVersions: builder.query<IVersionsResponseDto, null>({
      query: () => ({
        url: '/project_version/get_project_version/',
      }),
    }),
  }),
})

export const { useGetVersionsQuery } = versionsApi
